import React, { useState, useEffect } from "react";
import JobLinksSectionAdminPanel from "./JobLinksSectionAdminPanel";

function TopTextSectionAdminPanel() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  useEffect(() => {
    const syncDarkMode = () => setDarkMode(localStorage.getItem('darkMode') === 'true');
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);
  // Role check for superadmin only
  const role = localStorage.getItem('role');
  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }
  return (
    <div className={darkMode ? 'dark-mode' : ''}>
      <JobLinksSectionAdminPanel darkMode={darkMode} />
    </div>
  );
}

export default TopTextSectionAdminPanel;
